export default {
  info(...data) {
    console.log("[LOGGER INFO]:", ...data);
  },
  warn(...data) {
    console.warn("[LOGGER WARN]:", ...data);
  },
  error(...data) {
    console.error("[LOGGER ERROR]:", ...data);
  }
};
